module.exports = __webpack_public_path__ + "img/crm-logo.7c86b69c.svg";